import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
import ElementUI from 'element-ui';//引入ElementUI
import 'element-ui/lib/theme-chalk/index.css';
import animated from 'animate.css';//引入animate
import VueAwesomeSwiper from 'vue-awesome-swiper' // 导入组件
import VueiClient from '@supermap/vue-iclient-mapboxgl';//supermap
import VueAnimateNumber from 'vue-animate-number'   // 数字动效加载

Vue.use(VueAnimateNumber)   // 数字动效加载
Vue.use(dataV);
Vue.use(ElementUI);//全局注册插件
Vue.use(VueiClient);
Vue.use(animated)
import { Message } from 'element-ui'
Vue.component(Message)
// 引入vue-amap
// import AMap from 'vue-amap';
// Vue.use(AMap);
Vue.use(VueAwesomeSwiper)
import AmapVue from '@amap/amap-vue';
AmapVue.config.version = '2.0'; // 默认2.0，这里可以不修改
// AmapVue.config.key = '15f835ec1fb80b88c0ec3ff8f6f394851'; // key替换
AmapVue.config.key = '1c26e30abecdc9022e34e0a54fdc8d71';

AmapVue.config.plugins = [
  'AMap.moveAnimation',
  'AMap.Geocoder',
  // 在此配置你需要预加载的插件，如果不配置，在使用到的时候会自动异步加载
];
Vue.use(AmapVue);
// 过滤器
Vue.filter('unitsWan', function(value) {
  if(!value) return 0
  return (parseFloat(value, 10) / 10000).toFixed(0)
})

Vue.filter('overTenThousand', function (number) {
  return number > 10000 ? (number / 10000).toFixed(2) : number
})
Vue.filter('overTenThousandUnit', function (number) {
  number = parseFloat(number)
  return number > 10000 ? (number / 10000).toFixed(0) + 'w' : number
})

Vue.filter('overTenThousandUnitTwo', function (number) {
  number = parseFloat(number)
  return number > 10000 ? (number / 10000).toFixed(0)  : number
})

// 初始化vue-amap
// AMap.initAMapApiLoader({
//   // 申请的高德key
//   key: '03968a44c724704dfa904f1234c03555',
//   // 插件集合
//   plugin: [
// 	  "AMap.Autocomplete", // 输入提示插件
// 	  "AMap.PlaceSearch", // POI搜索插件
// 	  "AMap.Scale", // 右下角缩略图插件 比例尺
// 	  "AMap.OverView", // 地图鹰眼插件
// 	  "AMap.ToolBar", // 地图工具条
// 	  "AMap.MapType", // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
// 	  "AMap.PolyEditor", // 编辑 折线多，边形
// 	  "AMap.CircleEditor", // 圆形编辑器插件
// 	  "AMap.Geolocation", // 定位控件，用来获取和展示用户主机所在的经纬度位置
// 	  "AMap.ControlBar"
//   ]
// });

// 按需引入vue-awesome图标
// import Icon from 'vue-awesome/components/Icon';
// import 'vue-awesome/icons/chart-bar.js';
// import 'vue-awesome/icons/chart-area.js';
// import 'vue-awesome/icons/chart-pie.js';
// import 'vue-awesome/icons/chart-line.js';
// import 'vue-awesome/icons/align-left.js';
// 数据可视化大屏- 适配
// import 'amfe-flexible';

// 全局注册图标
// Vue.component('icon', Icon);

// 适配flex
// import '@/common/flexible.js';

// 引入全局css
import './assets/scss/index.scss';
import './assets/scss/style.scss';
import './assets/scss/main.scss';
// import './assets/scss/back.scss'

//引入echart
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue()


/**
 *  eventbus实现非父子组件之间的通信
 *  main.js 这种方式初始化的EventBus是一个全局的事件总线
 */
Vue.prototype.$EventBus = new Vue()

// 引入mixins
// import MixinLeft from '@/components/mixins/index';

Vue.mixin({
  mounted () {
    this.$EventBus.$on('update', (data) => {
      this.getData && this.getData(data);
    })
  },
  beforeDestroy() {
    this.$EventBus.$off('update');
  }
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
